import React, { FC, useContext, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
// import './home.css'
import { useLatestArticles } from "../../../common/hooks/useArticles";
import { Article } from "../../../common/types/articles";
import { Link, useNavigate } from "react-router-dom";
import { useHomeData } from "../../../common/hooks/useHomeData";
import AppContext from "../../../common/context/app-context";
import { Popup } from "../../../common/components/AuthModal";
import { GamePreview } from "../../../common/components/GamePreview";
import { ShowOffYourDogs } from "../../../common/types/home";
import { useTrackGoogleAnalyticsEventPages } from "../../../common/hooks/useTrackGoogleAnalyticsEvent";
import { IPhoneMocks } from "./appMocks/appMocks";
import LandingSection from "./landing-section";
import landingBg1Gold from "../../../assets/img/landing-page/landing_bg_1_gold.png";
import landingBg2Green from "../../../assets/img/landing-page/landing_bg_2_green.png";
import landingBg3Pink from "../../../assets/img/landing-page/landing_bg_3_pink.png";
import landingPowViolet from "../../../assets/img/landing-page/landing_pow_violet.png";
import landingStartGold from "../../../assets/img/landing-page/landing_star_gold.png";
import landingSquares from "../../../assets/img/landing-page/landing_squares.png";
import "./home.css";
const HomePage: FC = () => {
  const { data: latestArticles } = useLatestArticles();
  const navigate = useNavigate();
  const {
    me: currentUser,
    setShowAuthPopup,
    setIsNewSeq,
  } = useContext(AppContext);
  const { data: homeData } = useHomeData();

  useEffect(() => {
    useTrackGoogleAnalyticsEventPages();
  }, []);

  useEffect(() => {
    useTrackGoogleAnalyticsEventPages();
  }, []);

  const loginCheckHandler = (url: string) => {
    if (!currentUser) {
      setShowAuthPopup({ authStep: Popup.Login });
    } else {
      navigate(url);
    }
  };
  const handlePlayNowClick = () => {
    setIsNewSeq(true);
    navigate("game");
  };
  const getFeaturedArticleElement = (): JSX.Element | undefined => {
    const featured = homeData?.data.articles.find((a) => a.type === "main");
    return (
      <Link to={`/article/${featured?.slug}`}>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="article-media article-media--lg w-100 mb-6 sm-mb-2 no-scroll">
              <img
                className="img img--full img--contain br"
                src={featured?.thumbnailUrl}
                alt=""
              />
            </div>
            <div className="flex flex-col justify-start align-start">
              <span className="fs-xl lh-xl sm-fs-md sm-lh-md fw-700 c-primary  sm-mb-1">
                {featured?.subTopicSelections
                  ?.map((e) => e.subTopic.name)
                  .join(", ")}
              </span>
              <span className="fs-h-4 lh-h-4 sm-fs-h-6 sm-lh-h-5 xs-fs-h-7 xs-lh-h-7 fw-700 c-text-black mb-2 sm-mb-1">
                {featured?.title}
              </span>
              <span className="fs-lg lh-xl sm-fs-sm sm-lh-md fw-400 c-text-4">
                {featured?.excerpt}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div className="main_ontainer flex flex-col justify-center align-stretch bg-white">
      <div className="landing_new landing flex flex-col w-100 h-fit align-center justify-start xs-px-3 xs-py-0">
        {/* top banner */}
        <div
          id="download_banner"
          className="download-banner"
          style={{ display: "none" }}
        >
          <div className="bannerbody">
            <div className="banner-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 64 64"
                fill="none"
                className="icon"
              >
                <rect
                  x="12"
                  y="4"
                  width="40"
                  height="56"
                  rx="6"
                  ry="6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <rect
                  x="24"
                  y="10"
                  width="16"
                  height="4"
                  rx="2"
                  ry="2"
                  fill="currentColor"
                />
                <circle cx="32" cy="52" r="4" fill="currentColor" />
              </svg>

              <span className="banner-text">
                <strong>NEW!</strong> Download the iPhone App to play unlimited
                games and track your streak.
              </span>
            </div>
            <div className="banner-right">
              <button className="download-btn">Download Now</button>
              <span className="close-btn">✕</span>
            </div>
          </div>
        </div>
        <div
          className="w-100 left_full_area  flex align-center"
          style={{ margin: "", width: "85%", height: "90%" }}
        >
          <div className="flex  relative  align-center xs-flex-col w-100 align-stretch grow-1 xs-py-5">
            <div className="flex smallAreaIphone justify-center align-center grow-1  w-100 xs-flex-col-reverse col-gap-12 sm-col-gap-10 xs-col-gap-0">
              {/* mobile moc part */}
              <div
                className="media_left_tab  landing-left-dog-n-graphics relative justify-center  "
                style={{ backgroundColor: "" }}
              >
                {/* background graphics */}
                <div
                  style={{
                    width: "100%",
                    position: "absolute",
                    backgroundColor: "",
                  }}
                  className="landing-graphics"
                >
                  <div className="top-row ">
                    <div className="xs-hidden left-img ">
                      <img
                        src={landingPowViolet}
                        alt=""
                        className="landingPowViolet"
                      />
                    </div>
                    <div className="right-imgs ">
                      <img
                        src={landingBg1Gold}
                        style={{ marginLeft: "-50px" }}
                        alt=""
                        className="landingBg1Gold"
                      />
                      <img
                        src={landingStartGold}
                        // style={{ marginRight: "-100px" }}
                        alt=""
                        className="landingStartGold"
                      />
                    </div>
                  </div>

                  <div className="middle-row">
                    <img
                      src={landingSquares}
                      // style={{ marginRight: "-100px" }}
                      alt=""
                      className="landingSquares"
                    />
                  </div>

                  <div className="bottom-row">
                    <img src={landingBg3Pink} alt="" className="bottompink" />
                    <img src={landingBg2Green} alt="" className="bottomgreen" />
                  </div>
                </div>

                {/* iphone mocks */}
                <IPhoneMocks handlePlayNowClick={handlePlayNowClick} />
              </div>
              {/* <div className="custom_gap"></div> */}
              <LandingSection handlePlayNowClick={handlePlayNowClick} />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col xs-py-17 py-20 bg-primary-light-2 ">
        <h2 className="fs-h-2 lh-h-2 fw-700 c-text-2 text-uppercase text-center xs-pt-0 pt-20 mb-6 xs-fs-h-3 xs-lh-h-3 sm-fs-h-3 sm-lh-h-3 new_text show_off_your_god_text">
          show off your dog
        </h2>

        <div className="relative container flex flex-col justify-start align-stretch col-gap-2 mb-6 mt-2">
          <Swiper
            className="landing-dogs-slider w-100"
            spaceBetween={8}
            slidesPerView={4}
            centerInsufficientSlides={true}
            loop={false}
            modules={[Navigation]}
            navigation={{
              prevEl: ".landing-dogs-slider-btn--prev",
              nextEl: ".landing-dogs-slider-btn--next",
            }}
            breakpoints={{
              320: {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                centerInsufficientSlides: false,
              },
              768: {
                loop: false,
                slidesPerView: 4,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
              1280: {
                loop: false,
                slidesPerView: 4,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
            }}
          >
            {!!homeData?.data?.showOffYourDogs &&
              homeData.data.showOffYourDogs?.map((dog: ShowOffYourDogs) => (
                <SwiperSlide key={dog.id}>
                  <div className="flex flex-col justify-start align-stretch">
                    <div className="flex w-100 ">
                      <img
                        src={dog.imgUrl}
                        className="img img--full img--cover swiper-media"
                        alt=""
                      />
                    </div>
                    <div className="flex justify-between align-center col-gap-2 bg-primary-light py-2 px-4 xs-px-6">
                      <div className="flex flex-col tex-start justify-start grow-1 shrink-0">
                        <span className="fs-h-7 lh-h-7 sm-fs-xl sm-lh-xl xs-fs-md xs-lh-md fw-700 c-text-black new_text">
                          {dog.name}
                        </span>
                        <span className="fs-lg lh-lg sm-fs-md sm-lh-md xs-fs-sm xs-lh-sm c-text-1 fw-500 new_text">
                          {!!dog.description ? dog.description : <>&nbsp;</>}
                        </span>
                      </div>
                      <div className="flex flex-col justify-end align-end">
                        <span className="fs-lg lh-lg sm-fs-sm sm-lh-sm c-text-white fw-700 text-right new_text">
                          {`${dog.city},`}
                        </span>
                        <span className="fs-lg lh-lg sm-fs-sm sm-lh-sm c-text-white fw-700 text-right new_text">
                          {`${dog.state}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <button className="btn-reset landing-dogs-slider-btn landing-dogs-slider-btn--prev hidden xs-flex">
            <i className="flipicon flipicon--lg flipicon-left-circle">
              <span className="path1 c-text-1"></span>
              <span className="path2 c-primary-light"></span>
            </i>
          </button>
          <button className="btn-reset landing-dogs-slider-btn landing-dogs-slider-btn--next hidden xs-flex">
            <i className="flipicon flipicon--lg flipicon-right-circle">
              <span className="path1 c-text-1"></span>
              <span className="path2 c-primary-light"></span>
            </i>
          </button>
        </div>

        <div className="container flex flex-col justify-center align-center text-center mw-800 pb-10 xs-pb-20 xs-px-10">
          <span className="fs-lg lh-xl fw-400 c-text-4 mb-6 xs-fs-sm xs-lh-sm sm-fs-md sm-lh-sm new_text">
            Get your dog featured in the game! You can even share your own
            videos or send in questions about behavior and training. Is your dog
            our next Pup Star?{" "}
            <a
              onClick={() => loginCheckHandler("submit-dog-step-1")}
              className="fs-lg lh-xl fw-400 c-text-4 mb-6 xs-fs-sm xs-lh-sm sm-fs-md sm-lh-sm underline new_text"
            >
              Submit and find out.
            </a>
          </span>
          <div className="flex justify-center align-center xs-w-100">
            <Link
              to="submit-dog-step-1"
              state={{ showAuthPopup: true }}
              className="btn btn--primary xs-btn--lg xs-w-100"
            >
              <span className="new_text">submit my dog</span>
            </Link>
          </div>
        </div>
      </div>
      {!!homeData?.data.articles && (
        <>
          <div className="container flex flex-col w-100 justify-center align-center pt-20 xs-pt-0 xs-px-6">
            <div
              className="flex flex-row justify-center text-center align-center mb-20 xs-flex-col-reverse xs-mb-12
              "
            >
              <h2 className="text-uppercase fs-h-1 lh-h-1 sm-fs-h-3 sm-lh-h-3 xs-fs-h-3 xs-lh-h-3 fw-700 c-text-2">
                <span className="new_text">today's topics</span>
              </h2>
              <div className="flex topics-media">
                <img
                  className="img img--full img--contain"
                  src="/images/dog.png"
                  alt=""
                />
              </div>
            </div>
            <div className="flex flex-row w-100 col-gap-10 sm-col-gap-8 sm-px-6 xs-px-0 xs-flex-col">
              <div className="flex flex-col row-gap-20 sm-row-gap-10 xs-row-gap-12 topics-main">
                {getFeaturedArticleElement()}
                <div className="flex flex-col grow-1 justify-start ">
                  <div className="flex mb-10 sm-mb-5">
                    <span className="fs-h-4 lh-h-4 sm-fs-h-6 sm-lh-h-6 xs-fs-h-5 xs-lh-h-5 fw-700 c-text-2">
                      <span className="new_text">Latest</span>
                    </span>
                  </div>
                  <div className="flex flex-row col-gap-6 xs-flex-col">
                    {!!homeData?.data.articles &&
                      homeData?.data.articles
                        ?.filter((item) => item.type === "latest")
                        .map((article: Article) => (
                          <Link
                            to={`/article/${article.slug}`}
                            key={article.id}
                          >
                            <div className="flex flex-col">
                              <div className="article-media article-media--sm mb-6 sm-mb-2">
                                <img
                                  className="img img--full img--contain br"
                                  src={article.thumbnailUrl}
                                  alt={article.title}
                                />
                              </div>
                              <div className="flex flex-col align-start justify-start xs-mt-2 xs-mb-6">
                                <span className="fs-xl lh-xl sm-fs-md sm-lh-md fw-700 c-primary mb-2 sm-mb-1 xs-mb-1">
                                  <span className="new_text">
                                    {article?.subTopicSelections
                                      ?.map((e) => e.subTopic.name)
                                      .join(", ")}
                                  </span>
                                </span>
                                <span className="fs-h-4 lh-h-4 sm-fs-xl sm-lh-h-7 fw-700 c-text-black">
                                  <span className="new_text">
                                    {article.title}
                                  </span>
                                </span>
                                <span className="fs-lg lh-xl sm-fs-sm sm-lh-md fw-400 c-text-4">
                                  <span className="new_text">
                                    {article.excerpt}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </Link>
                        ))}
                  </div>
                </div>
              </div>
              <div className="flex flex-col grow-1 justify-start align-start topics-sidebar xs-mt-12">
                <div className="flex mb-6 w-100 border-b pb-6 sm-pb-3 sm-mb-4">
                  <span className="fs-h-4 lh-h-4 sm-fs-h-6 sm-lh-h-6 fw-700 c-text-2">
                    <span className="new_text">Trending</span>
                  </span>
                </div>
                {latestArticles?.map((article: Article, index: number) => (
                  <Link
                    to={`/article/${article.slug}`}
                    key={article.id}
                    className="flex flex-col w-100"
                  >
                    <div
                      className={`flex flex-col w-100 align-start border-b pb-6 sm-pb-3 xs-mb-4 xs-pb-4
                  ${index < latestArticles?.length - 1 ? "mb-6 sm-mb-3" : ""}`}
                    >
                      <div className="flex flex-row w-100 justify-between mb-6 sm-mb-3">
                        <span className="fs-xl lh-xl sm-fs-md sm-lh-md fw-700 c-primary sm-mr-1">
                          {article?.subTopicSelections
                            ?.map((e) => e.subTopic.name)
                            .join(", ")}
                        </span>
                      </div>
                      <div className="flex flex-col w-100 justify-start align-start align-start">
                        <span className="fs-h-4 lh-h-4 sm-fs-h-6 sm-lh-h-6 xs-fs-h-7 xs-lh-h-7 fw-700 c-text-black mb-2">
                          <span className="new_text">{article.title}</span>
                        </span>
                        <span className="fs-lg lh-xl sm-fs-sm sm-lh-md fw-400 c-text-4">
                          <span className="new_text">{article.excerpt}</span>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="flex justify-center align-center mb-15 mt-15 xs-w-100 xs-px-10">
            <Link to="/topics" className="btn btn--primary xs-btn--lg xs-w-100">
              <span className="new_text">see all topics</span>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default HomePage;
